<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.78256 5.49105C9.50156 5.18605 9.02656 5.16905 8.72256 5.44905C8.41856 5.72905 8.39956 6.20405 8.68056 6.50905L13.7486 12.0001L8.67956 17.4911C8.39956 17.7961 8.41856 18.2701 8.72256 18.5511C8.86756 18.6841 9.04856 18.7491 9.23156 18.7491C9.43256 18.7491 9.63456 18.6691 9.78356 18.5091L15.7896 12.0001L9.78256 5.49105Z"
		fill="currentColor"
	/>
</svg>
